import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedService: "",
  selectedShop: {},
  orderFlow: "",
  pickupDetails: {},
  orderDetails: {},
  selectedCart: {},
  shopPayload: {},
  shopDetails: {},
  payloadAddress: {},
  cartItems: [],
};

const customerSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setOrderFlow: (state, action) => {
      state.orderFlow = action.payload;
    },
    setSelectedShop: (state, action) => {
      state.selectedShop = action.payload;
    },
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    setOrderDetails: (state, action) => {
      state.orderDetails = action.payload;
    },
    setPickupDetails: (state, action) => {
      state.pickupDetails = action.payload;
    },
    clearOrderDetails: (state) => {
      state.pickupDetails = {};
      state.cart = {};
      state.selectedService = null;
      state.selectedCart = {};
      state.pound = 1;
      state.cartItems = [];
      state.selectedShop = {};
      state.orderFlow ='';
      state.cartItems = [];
      state.shopDetails ={};
    },
    setCartDetails: (state, action) => {
      state.selectedCart = action.payload.cart;
      state.pound = action.payload.pound;
    },
    setShopPayload: (state, action) => {
      state.shopPayload = action.payload;
    },
    setShopDetails: (state, action) => {
      state.shopDetails = action.payload;
    },
    setPayloadAddress: (state, action) => {
      state.payloadAddress = action.payload;
    },

    setCartItems: (state, action) => {
     state.cartItems = [
    ...state.cartItems,
    {
      name: action.payload.name,
      weight: action.payload.weight,
      tailoringType: action.payload.tailoringType,
      category: action.payload.category
    }
     ];
  },
removeCartItem: (state, action) => {
  state.cartItems = state.cartItems.filter(
    (item) => item.name !== action.payload.name
  );
},

updateCartItem: (state, action) => {
  const { name, weight, tailoringType, category } = action.payload;
  if (weight <= 0) {
    state.cartItems = state.cartItems.filter((item) => item.name !== name);
    return;
  }
    const index = state.cartItems.findIndex((item) => item.name === name);

  if (index !== -1) {
    state.cartItems[index] = {
      ...state.cartItems[index],
      weight,
      tailoringType,
      category,
    };
  } else {
    // If not in cart, add it
    state.cartItems.push({ name, weight, tailoringType, category });
  }
}

  },
});

export const {
  setOrderFlow,
  setSelectedShop,
  setSelectedService,
  setPickupDetails,
  setOrderDetails,
  clearOrderDetails,
  setCartDetails,
  setShopPayload,
  setShopDetails,
  setPayloadAddress,
 removeCartItem,
  setCartItems,
  updateCartItem
} = customerSlice.actions;
export default customerSlice.reducer;
